import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderModule } from '../loaders/loader.module';
import { ToolbarComponent } from './toolbar.component';
import { CustomFilterComponent } from './custom-filter/custom-filter.component';
import { SelectorChipsModule } from '../selector/selector-chips/selector-chips.module';
import { ActionsBarComponent } from './actions-bar/actions-bar.component';
import { SelectorModule } from '../selector/selector.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectorChipsTabsModule } from '../selector/selector-chips-tabs/selector-chips-tabs.module';
import { CustomFilterChipsComponent } from './custom-filter-chips/custom-filter-chips.component';

@NgModule({
  declarations: [
    ToolbarComponent,
    CustomFilterComponent,
    ActionsBarComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatButtonModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSelectModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    TranslateModule,
    LoaderModule,
    MatTooltipModule,
    SelectorChipsModule,
    SelectorModule,
    SelectorChipsTabsModule,
    CustomFilterChipsComponent
  ],
  exports: [
    ToolbarComponent,
    CustomFilterComponent,
    ActionsBarComponent
  ]
})
export class ToolbarModule { }
